import React from 'react';

export const PageContentContext = React.createContext({
  pages: [],
  settings: [],
  refreshPages: async () => null,
  suggestions: [],
  onSaveContentNode: async () => null,
});

export const PageContentProvider = PageContentContext.Provider;
